import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { CustomerInfoForm } from '@app/components/forms/CustomerInfoForm/CustomerInfoForm';
import { TabCard } from '@app/components/layouts/TabCard/TabCard';
import StatusBar from '@app/components/statusBar/statusBar';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Form, Modal, notification } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ProductInfo from './ProductRegistrationInfo';
import ImpFreeSalesNewReg from './ProdRegForms/ImportFreeSales/ImpFreeSalesNewReg';
import AdditionalInfoForm from './ProdRegForms/commonForms/AdditionalInfoForm';
import ProductListForm from './ProdRegForms/commonForms/ProductListForm';
import {
  showIFS,
  editIFS,
  createIFS,
  storeIFS,
  updateIFS,
  renewRegistration,
  appealRegistration,
} from '@app/api/prImportFreeSales.api';
import { notificationController } from '@app/controllers/notificationController';
import CommentsTab from '../common/Comments';
import DocumentChecklist from './DocumentChecklist';
import CertificateList from './AllPRCertificates';
import PaymentsInfo from './PaymentInfo';
import SiteVisitsTab from './ProdRegForms/SiteVisits';
import FarmLocationSelector from './ProdRegForms/FarmSelection';
import { get } from '@app/api/http.api';

interface ProductRegistrationProps {
  id?: string;
  type: 'edit' | 'create' | 'view';
  pageTitle: string;
  editable: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setCurrentBreadcrumName: Function;
}

export const ProductRegistration: React.FC<ProductRegistrationProps> = ({ id, type, setCurrentBreadcrumName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { addHeaderButton, removeHeaderButton } = useHeader();
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState('1');
  const [status, setStatus] = useState<string | null>(null);
  const [isLoading, setLoading] = useState(false);
  const ifsId = id ? parseInt(id) : null;
  const [formData, setFormData] = useState<{
    impFreeSales: any;
    productList: any;
    additionalInfo: any;
    customerInfo: any;
    farmLocation: any | null;
  }>({
    impFreeSales: {},
    productList: {},
    additionalInfo: {},
    customerInfo: JSON.parse(localStorage.getItem('user') || '{}'),
    farmLocation: {},
  });
  const [prTypesOptions, setPrTypesOptions] = useState<any[]>([]);
  const [countryOptions, setCountryOptions] = useState<any[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<any[]>([]);
  const [prProductOptions, setPrProductOptions] = useState<any[]>([]);
  const [FormFields, setFormFields] = useState<any[]>([]);
  const [DocFormFields, setDocFormFields] = useState<any[]>([]);
  const [IniDocFormFields, setIniDocFormFields] = useState<any[]>([]);
  const [comments, setComments] = useState<any[]>([]);
  const [wfActions, setWfActions] = useState<string[]>([]);
  const [pr_code, setPRCode] = useState('New');
  const [pr_type, setPRType] = useState('NEW');
  const [product_type, setProductType] = useState('SINGLE');
  const [isRenewable, setRenewable] = useState(false);
  const [isAppeal, setAppeal] = useState(false);
  const [isAmmendable, setAmmendable] = useState(false);
  const [cdata, setCdata] = useState(false);
  const [cansetValidity, setValidity] = useState(false);
  const [related_id, setRelatedId] = useState<number | null>(null);
  const [appealAttempt, setAppealAttempt] = useState<string | null>(null);
  const [appealNo, setAppealNo] = useState<number | null>(null);
  const [invoiceActions, setInvoiceActions] = useState<Record<string, boolean>>({});
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const [prLocationData, setprLocationData] = useState<any[]>([]);
  const [isCatEditable, setCatEditable] = useState(false);
  const [visitDocs, setVisitDocs] = useState<Record<string, any[]>>({});
  const [feedForms, setFeedForms] = useState<Record<string, any>>({});
  const [prLocationOptions, setPrLocationOptions] = useState<any[]>([]);
  const [total, setTotal] = useState<string | number | null>(null);
  const formRefs = {
    productList: useRef<any>(null),
    additionalInfo: useRef<any>(null),
    impFreeSales: useRef<any>(null),
    customerInfo: useRef<any>(null),
    checklistData: useRef<any>(null),
    farmLocation: useRef<any>(null),
  };

  const forms = {
    impFreeSales: Form.useForm()[0],
    productList: Form.useForm()[0],
    additionalInfo: Form.useForm()[0],
    customerInfo: Form.useForm()[0],
    checklistData: Form.useForm()[0],
    farmLocation: Form.useForm()[0],
  };

  const [currentType, setCurrentType] = useState<'edit' | 'create' | 'view'>(type);
  const isEditable = currentType === 'create' || currentType === 'edit';
  const isPoultry = localStorage.getItem('isPoultry') || false;

  useEffect(() => {
    const isDraftOrNew = !status || status === 'DRAFT';
    const showEditbtn = status === 'DRAFT';

    const buttons = {
      'save-button': isEditable && isDraftOrNew && (
        <BaseButton type="primary" loading={isLoading} size="small" onClick={handleSave}>
          Save
        </BaseButton>
      ),
      'cancel-button': isEditable && isDraftOrNew && (
        <BaseButton onClick={() => navigate(-1)} size="small" style={{ marginRight: '8px' }}>
          {t('Cancel')}
        </BaseButton>
      ),
      'edit-button': currentType === 'view' && showEditbtn && (
        <BaseButton type="primary" loading={isLoading} size="small" onClick={() => setCurrentType('edit')}>
          Edit
        </BaseButton>
      ),
      'renew-button': currentType === 'view' && status === 'DONE' && isRenewable && (
        <BaseButton type="primary" loading={isLoading} size="small" onClick={handleRenew}>
          Renew
        </BaseButton>
      ),
      'appeal-button': currentType === 'view' && status === 'REJECTED' && isAppeal && (
        <BaseButton type="primary" loading={isLoading} size="small" onClick={handleAppeal}>
          Appeal
        </BaseButton>
      ),
    };

    Object.entries(buttons).forEach(([key, button]) => button && addHeaderButton(key, button));

    return () => Object.keys(buttons).forEach(removeHeaderButton);
  }, [currentType, id, isEditable, addHeaderButton, removeHeaderButton, t, navigate, isLoading, status]);

  const storedCatId = localStorage.getItem('selected_category_id');
  const cat_id = storedCatId ? Number(storedCatId) : 2;

  const fetchedRef = useRef(false);

  useEffect(() => {
    // if (fetchedRef.current) return;
    // fetchedRef.current = true;

    setLoading(true);

    const fetchData = async () => {
      try {
        const res =
          ifsId && currentType === 'view'
            ? await showIFS(ifsId)
            : ifsId && currentType === 'edit'
            ? await editIFS(ifsId)
            : currentType === 'create'
            ? await createIFS(cat_id)
            : null;

        if (res) {
          setFormFields(res?.product_registration?.pr_product?.pr_category?.pr_fields || []);
          setIniDocFormFields(Object.values(res?.product_registration?.pr_documents || []));
          setDocFormFields(res.product_registration?.pr_product.pr_category.pr_document_collections || []);
          setProductType(res.product_registration?.pr_product?.pr_category.product_type || 'SINGLE');
          setPrTypesOptions(res.pr_types_options || []);
          setCountryOptions(res.country_options || []);
          setDepartmentOptions(res.department_options || []);
          setPrProductOptions(res.pr_product_options || []);
          setStatus(res?.product_registration?.status ?? null);
          setWfActions(res?.wf_actions ?? []);
          setComments(res?.product_registration?.pr_comments || []);
          setCurrentBreadcrumName(res?.product_registration?.code || 'New');
          setPRCode(res?.product_registration?.code || 'New');
          setPRType(res?.product_registration?.pr_type || 'PR - IFS');
          setRelatedId(res?.product_registration?.related_id ?? null);
          setAppealAttempt(res?.product_registration?.appeal ?? null);
          setAppealNo(res?.product_registration?.appeal_no ?? null);
          setRenewable(res?.product_registration?.can_renew ?? false);
          setValidity(res?.product_registration?.can_set_validity ?? false);
          setAppeal(res?.product_registration?.can_appeal ?? false);
          setAmmendable(res?.product_registration?.can_amend ?? false);
          setCatEditable(res?.product_registration?.can_update_catalog ?? false);
          setCdata(res?.product_registration?.editable_cdata ?? false);
          setInvoiceActions(res?.invoice_actions ?? {});
          setInvoiceData(res?.product_registration?.invoices ?? []);
          setTotal(res?.product_registration?.invoices?.[0]?.total ?? null);
          setprLocationData(res?.product_registration?.pr_location || []);
          setPrLocationOptions(res.pr_location_options || []);
          const prVisitDocs = res?.product_registration?.pr_visit_documents;
          if (prVisitDocs && typeof prVisitDocs === 'object' && !Array.isArray(prVisitDocs)) {
            setVisitDocs(prVisitDocs);
          } else {
            setVisitDocs({});
          }
          if (res?.pr_feed_related_forms) {
            console.log('setting feed forms:', res.pr_feed_related_forms);
            setFeedForms(res.pr_feed_related_forms);
          }

          const initialFormData = {
            impFreeSales: {
              ...(res?.product_registration?.pr_info?.informations ?? null),
              pr_product_id: res?.product_registration?.pr_product_id ?? null,
              pr_type: res?.product_registration?.pr_type ?? null,
              country_id: res?.product_registration?.country_id ?? null,
            },
            customerInfo: {
              ...(res?.product_registration?.customer || JSON.parse(localStorage.getItem('user') || '{}')),
              status: res?.product_registration?.customer?.user?.status ?? null,
              email: res?.product_registration?.customer?.user?.email ?? null,
            },
            additionalInfo: {
              department_id: res?.product_registration?.department_id ?? null,
              collected_type: res?.product_registration?.collected_type ?? null,
              delivery_address: res?.product_registration?.delivery_address ?? '',
            },
            productList: {
              ...(res?.product_registration?.pr_product_catalog ?? {}),
              productList: (() => {
                const catalogData = res?.product_registration?.pr_product_catalog?.catalog;
                if (!catalogData) return [];

                const catalogArray = Array.isArray(catalogData) ? catalogData : [catalogData];
                let fields: string[] = [];

                if (product_type === 'SINGLE') {
                  fields = ['product_name', 'description'];
                } else if (product_type === 'MULTIPLE') {
                  fields = ['product_name', 'description', 'imp_qty', 'man_qty'];
                } else {
                  fields = ['product_name', 'generic_names', 'species'];
                }

                return catalogArray.map((item, index) => ({
                  key: index.toString(),
                  ...Object.fromEntries(
                    fields.map((field) => [field, item[field] ?? (Array.isArray(item[field]) ? [] : '')]),
                  ),
                }));
              })(),
            },

            checklistData: {
              ...res?.product_registration?.pr_documents,
            },
            farmLocation: null,
          };
          setFormData(initialFormData);

          // Set values in forms
          forms.impFreeSales.setFieldsValue(initialFormData.impFreeSales);
          forms.productList.setFieldsValue(initialFormData.productList);
          forms.additionalInfo.setFieldsValue(initialFormData.additionalInfo);

          // Store data in refs
          if (formRefs.impFreeSales.current?.setData) {
            formRefs.impFreeSales.current.setData(initialFormData.impFreeSales);
          }
          if (formRefs.productList.current?.setData) {
            formRefs.productList.current.setData(initialFormData.productList);
          }
          if (formRefs.additionalInfo.current?.setData) {
            formRefs.additionalInfo.current.setData(initialFormData.additionalInfo);
          }
        }
      } catch (err: any) {
        notification.error({ message: 'Failed to fetch product data', description: err.message });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [ifsId, currentType, status]);

  useEffect(() => {
    if (formData.farmLocation) {
      console.log('Updated formData.farmLocation:', formData.farmLocation);
    }
  }, [formData.farmLocation]);

  const getCategorySpecificDataDynamic = (formRef: any) => {
    if (!formRef?.current?.getData) return {};
    return formRef.current.getData();
  };

  const handleSave = () => {
    Object.values(formRefs).forEach((ref) => {
      if (ref?.current?.submitForm) {
        ref.current.submitForm();
      }
    });

    const getFormData = (formInstance: any, formRef: any, stateData: any) => {
      // First try to get data from the ref's getData method
      if (formRef?.current?.getData) {
        const refData = formRef.current.getData();
        if (refData && Object.keys(refData).length > 0) {
          return refData;
        }
      }

      // Then try form values as fallback
      const formValues = formInstance.getFieldsValue();
      if (Object.keys(formValues).length > 0 && Object.values(formValues).some((val) => val !== undefined)) {
        return formValues;
      }

      // Fall back to state data as last resort
      return stateData;
    };

    const getProductListArray = (data: any, product_type: any) => {
      if (!data) return null;

      // If data already contains `catalog`
      if (data.catalog) {
        return product_type === 'MULTIPLE' ? data.catalog : data.catalog;
      }

      // single object
      if (data.productName) {
        if (product_type === 'MULTIPLE') {
          return [
            {
              product_name: data.productName,
              description: data.description,
              imp_qty: data.impQty,
              man_qty: data.manQty,
            },
          ];
        } else if (product_type === 'SINGLE') {
          return {
            product_name: data.productName,
            generic_names: data.genericNames,
            species: data.species,
          };
        }
      }

      return null;
    };

    const impFreeSalesData = getFormData(forms.impFreeSales, formRefs.impFreeSales, formData.impFreeSales);
    const categorySpecificData = getCategorySpecificDataDynamic(formRefs.impFreeSales);
    const productListData = getFormData(forms.productList, formRefs.productList, formData.productList);
    const productListArray = getProductListArray(productListData, product_type);
    const additionalInfoData = getFormData(forms.additionalInfo, formRefs.additionalInfo, formData.additionalInfo);
    // const FarmLocationData = getFormData(forms.farmLocation, formRefs.farmLocation, formData.farmLocation);

    if (!additionalInfoData?.department_id) {
      notification.error({
        message: 'Validation Error',
        description: 'Department is required. Please select a department before submitting.',
      });
      return;
    }

    let selectedFarmId = null;
    if (product_type === 'LOCATION') {
      const farmLocationFromRef = formRefs.farmLocation?.current?.getData();
      const farmLocationData = farmLocationFromRef || formData.farmLocation;

      if (!farmLocationData?.id) {
        notification.error({
          message: 'Validation Error',
          description: 'Please select a farm location before submitting.',
        });
        return;
      }
      selectedFarmId = parseInt(farmLocationData.id.toString(), 10);
      console.log('Selected farm ID:', selectedFarmId);
    }

    if (product_type !== 'LOCATION' && (!productListArray || productListArray.length === 0)) {
      notification.error({
        message: 'Validation Error',
        description: 'Product list cannot be empty or invalid. Please add at least one product.',
      });
      return;
    }

    const customerId = JSON.parse(localStorage.getItem('user') || '{}')?.customer?.id ?? 1;

    const catalog = productListArray;

    const consolidatedData = {
      customer_id: customerId,
      pr_product_id: impFreeSalesData?.pr_product_id,
      pr_type: impFreeSalesData?.pr_type ?? 'NEW',
      related_id: impFreeSalesData?.related_id ?? null,
      country_id: impFreeSalesData?.country_id,
      expires_at: impFreeSalesData?.expires_at ?? '2025-12-31',
      date: new Date().toISOString().split('T')[0],
      collected_type: additionalInfoData.collected_type,
      department_id: additionalInfoData?.department_id ?? null,
      delivery_address: additionalInfoData?.delivery_address ?? '',
      catalog: product_type === 'LOCATION' || !catalog || catalog.length === 0 ? null : catalog,
      pr_location_id: selectedFarmId,
      ...categorySpecificData,
    };

    const action = type === 'create' ? storeIFS(consolidatedData) : ifsId ? updateIFS(ifsId, consolidatedData) : null;

    action
      ?.then((res: any) => {
        setLoading(false);
        navigate(`/product-registrations`, { state: { id: res?.data?.id } });
      })
      .catch((err: any) => {
        notificationController.error({ message: err.message });
        setLoading(false);
      });
    submitProductData(consolidatedData);
  };

  const submitProductData = (data: any) => console.log('Submitting data:', data);

  const handleRenew = async () => {
    if (!ifsId) {
      notification.error({ message: 'Renewal failed', description: 'No IFS ID found' });
      return;
    }

    Modal.confirm({
      title: 'Confirm Renewal',
      content: 'Are you sure you want to renew?',
      onOk: async () => {
        try {
          const response = await renewRegistration(ifsId);
          notification.success({ message: 'Success', description: 'Registration renewal initiated successfully' });
          navigate('/edit-product-registrations-renewal', {
            state: { id: response.data.id, related_id: ifsId, related_code: pr_code },
          });
        } catch (err: any) {
          notification.error({
            message: 'Renewal Error',
            description: err.response?.data?.errors?.catalog?.[0] || err.message || 'An error occurred',
          });
        }
      },
    });
  };

  const handleAppeal = async () => {
    try {
      if (!ifsId) {
        notification.error({ message: 'Appeal failed', description: 'No IFS ID found' });
        return;
      }

      Modal.confirm({
        title: 'Confirm Appeal',
        content: 'Are you sure you want to appeal?',
        onOk: async () => {
          try {
            const response = await appealRegistration(ifsId);
            notification.success({ message: 'Success', description: 'Appeal submitted successfully' });
            navigate('/edit-product-registrations-appeal', {
              state: {
                id: response.data.id,
                related_id: ifsId,
                related_code: pr_code,
              },
            });
          } catch (err: any) {
            notification.error({
              message: 'Appeal Error',
              description: err.response?.data?.errors?.catalog?.[0] || err.message || 'An error occurred',
            });
          }
        },
      });
    } catch (err: any) {
      notification.error({ message: 'Error', description: err.message || 'An error occurred' });
    }
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userType = user?.usertype;

  const tabs = useMemo(
    () => [
      {
        key: '1',
        title: t('Customer Info'),
        content: <CustomerInfoForm form={forms.customerInfo} type={type} customerInfo={formData.customerInfo} />,
      },
      {
        key: '2',
        title: t('New Registration'),
        content: (
          <ImpFreeSalesNewReg
            editable={isEditable}
            onSubmit={(data) => {
              setFormData((prev) => ({ ...prev, impFreeSales: data }));
            }}
            status={status}
            form={forms.impFreeSales}
            ref={formRefs.impFreeSales}
            productsOptions={prProductOptions}
            countryOptions={countryOptions}
            productTypeOptions={prTypesOptions}
            formFields={FormFields}
            related_id={related_id}
            isRenewable={isRenewable}
            editable_cdata={cdata}
            PR_type={pr_type}
            pr_id={id ?? null}
            appeal={appealAttempt}
            appeal_no={appealNo}
            pr_feed_related_forms={feedForms}
            product_type={product_type}
          />
        ),
      },
      ...(product_type !== 'LOCATION'
        ? [
            {
              key: '3',
              title: t('Product List'),
              content: (
                <ProductListForm
                  status={status}
                  editable={isEditable}
                  onSubmit={(data) => setFormData((prev) => ({ ...prev, productList: data }))}
                  form={forms.productList}
                  ref={formRefs.productList}
                  isAmmendable={isAmmendable}
                  isCatEditable={isCatEditable}
                  pr_id={id ?? null}
                  productListData={formData.productList}
                  product_type={product_type}
                  pr_type={pr_type}
                />
              ),
            },
          ]
        : []),
      ...(product_type === 'LOCATION'
        ? [
            {
              key: '4',
              title: t('Establishement / Farm'),
              content: (
                <FarmLocationSelector
                  editable={isEditable}
                  ref={formRefs.farmLocation}
                  prLocations={prLocationOptions}
                  onFarmSelect={(farm) => setFormData((prev) => ({ ...prev, farmLocation: farm as any }))}
                  prLocationData={prLocationData}
                  pr_type={pr_type}
                />
              ),
            },
          ]
        : []),
      ...(status !== null && status !== 'DRAFT'
        ? [
            {
              key: '5',
              title: t('Document Checklist'),
              content: (
                <DocumentChecklist
                  editable={isEditable}
                  initialformFields={IniDocFormFields}
                  formFields={DocFormFields}
                  status={status}
                  pr_id={id ?? null}
                  productListData={formData.productList}
                  prLocationData={prLocationData}
                  product_type={product_type}
                />
              ),
            },
          ]
        : []),
      {
        key: '6',
        title: t('Additional Info'),
        content: (
          <AdditionalInfoForm
            editable={isEditable}
            status={status}
            onSubmit={(data) => setFormData((prev) => ({ ...prev, additionalInfo: data }))}
            form={forms.additionalInfo}
            ref={formRefs.additionalInfo}
            departmentOptions={departmentOptions}
            pr_id={id ?? null}
            canSetValidity={cansetValidity}
          />
        ),
      },
      ...(type !== 'create' &&
      status !== 'DRAFT' &&
      status !== 'PENDING_REVIEW' &&
      status !== 'PENDING_DOCUMENT' &&
      status !== 'PENDING_DVRA_APPROVAL' &&
      product_type === 'LOCATION' &&
      isPoultry
        ? [
            {
              key: '7',
              title: t('Site Visits'),
              content: <SiteVisitsTab status={status} pr_id={id ?? null} visitDocs={visitDocs} />,
            },
          ]
        : []),

      ...(type !== 'create'
        ? [
            {
              key: '8',
              title: t('Comments'),
              content: <CommentsTab status={status} commentData={comments} pr_id={id ?? null} />,
            },
          ]
        : []),
      ...(status !== 'DRAFT' && status !== 'PENDING_DOCUMENT' && type !== 'create'
        ? [
            {
              key: '9',
              title: t('Payments'),
              content: (
                <PaymentsInfo
                  id={id ?? null}
                  pr_code={pr_code}
                  invoice_data={invoiceData}
                  PRstatus={status}
                  wfActions={wfActions || []}
                  InvoiceActions={invoiceActions}
                  invoicetype={'product_registration'}
                  total={total}
                />
              ),
            },
          ]
        : []),
      ...((userType === 'ADMIN' &&
        (status === 'PENDING_DO_APPROVAL' ||
          status === 'DONE' ||
          status === 'PENDING_REGISTRAR_APPROVAL' ||
          status === 'PENDING_CERTIFICATE_COLLECTION' ||
          // status === 'PENDING_DVRA_FINAL_APPROVAL' ||
          status === 'PENDING_VS_APPROVAL')) ||
      (userType === 'CUSTOMER' && (status === 'PENDING_CERTIFICATE_COLLECTION' || status === 'DONE'))
        ? [
            {
              key: '10',
              title: t('Certificate'),
              content: <CertificateList id={id ?? null} pr_code={pr_code} PRstatus={status} />,
            },
          ]
        : []),
    ],
    [currentType, isEditable, status, FormFields, formData.productList, userType],
  );

  return (
    <BaseRow gutter={[16, 16]}>
      <BaseCol span={24}>
        <StatusBar
          id={id ?? null}
          status={status}
          setStatus={setStatus}
          wfActions={wfActions || []}
          currentType={currentType}
          workflowType="product_registration"
          onViewInvoicesClick={() => setActiveTab('9')}
        />
      </BaseCol>
      <BaseCol span={24}>
        <TabCard tabs={tabs} defaultActiveKey="1" activeKey={activeTab} onChange={setActiveTab} title={pr_code} />
      </BaseCol>
      {/* {activeTab === '1' && (
        <BaseCol span={24} style={{ marginTop: '1rem' }}>
          <ProductInfo
            productInfo={[
              { title: 'Product Registration - Import Free Sales', code: 'CODE123', validity: '30 Days' },
              { title: 'Product Registration - Import Free Sales', code: 'CODE456', validity: '60 Days' },
            ]}
            productDetails={{
              job_id: pr_code,
              job_type: pr_type,
              status: status ?? '',
            }}
          />
        </BaseCol>
      )} */}
    </BaseRow>
  );
};
